import { createAction } from 'redux-act';
import { TLegacyErrors } from '@alycecom/services';
import { createAsyncAction } from '@alycecom/utils';

import { IBaseRequestParams } from '../../../../store/types/Request.types';

import { IThanksResponse } from './thanks.types';

const PREFIX = 'RECIPIENT/THANKS';

export const thanksStatusRequest = createAction<IBaseRequestParams>(`${PREFIX}/THANKS_STATUS_REQUEST`);
export const thanksStatusSuccess = createAction<IThanksResponse>(`${PREFIX}/THANKS_STATUS_SUCCESS`);
export const thanksStatusFail = createAction<TLegacyErrors>(`${PREFIX}/THANKS_STATUS_FAIL`);

export const sendThanksRequest = createAction<IBaseRequestParams & { message: string }>(
  `${PREFIX}/SEND_THANKS_REQUEST`,
);
export const sendThanksSuccess = createAction<void>(`${PREFIX}/SEND_THANKS_SUCCESS`);
export const sendThanksFail = createAction<TLegacyErrors>(`${PREFIX}/SEND_THANKS_FAIL`);

export const pollThanksRedeemStatus = createAsyncAction<
  IBaseRequestParams,
  IThanksResponse,
  TLegacyErrors,
  IThanksResponse
>(`${PREFIX}/POLL_THANKS_REDEEM_STATUS`);
